import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight} from "@fortawesome/free-solid-svg-icons";
import Modal from "../modal/modal";
import AddCdd from "../modal/pipline-modal/AddCdd";
import { useAuth } from "../../../services/auth-services/authContext";
import { AuthContextState } from "../../../utils/types";
import StatusFilter from "../buttons/pipeline/StatusFilter";
import ColumnFilters from "../buttons/pipeline/ColumnFilters";
import CddPipeLineTable from "./CddPipelineTable";
import { useState } from "react";
import ConversionRateDashboard from "./ConversionRateDashboard";
import CalculateRevenueBtn from "../buttons/pipeline/CalculateRevenueBtn";

interface PipelineData {
  pipeline_id : number;
  cdd_name: string;
  client_id : number;
  role : string;
  revenue: string;
  processed_date: string; 
  status: number;
  notes: string;
  projected_start_date: string; 
  client_name: string;
  career_level: string;
  cdd_num: string;
  add_candidates_or_switch_roles: string;
  last_update : string;
}

const CddPipeLine = () => {
    const currentYear = new Date().getFullYear();
    const [year, setYear] = useState<number>(currentYear);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);
    const [filterNum, setFilterNum] = useState<number[]>([]);
    const [filterCol, setFilterCol] = useState<string[]>([]);
    const [searchText, setSearchText] = useState<string>('');
    const {decodedJwtData} = useAuth() as AuthContextState;
    const [db_pipeline, set_db_pipeline] = useState<PipelineData[] | null>(null);
    const account_id = decodedJwtData?.userId;
    const name = decodedJwtData?.fullname.split(' ')[0];

    function createModalContent(content : React.JSX.Element){
        setModalChildren(content);
        setShowModal(true);
    }

    const incrementYear = () => { 
        setYear(prevYear => prevYear + 1)
    };

    const decrementYear = () => {
        setYear(prevYear => prevYear - 1)
    };

    return(
        <div className="content flex">
            <Helmet>
                <title>CDD Pipeline</title>
            </Helmet>

            <SideBar />
            <div className='main-content'>
                <div>
                    <h1 className="uppercase">
                       CDD Pipeline
                    </h1>
                </div>
                <div className="flex gap-4 my-4">
                    {/* Client card */}
                    <div className="bg-gray-100 p-2 shadow w-full relative">
                        <div className="my-2">
                            <h2>CANDIDATES IN THE PIPE</h2>
                        </div>
                        {/* Conversion rate dashboard */}
                        <ConversionRateDashboard pipeline={db_pipeline ?? []} recruiter={name ?? ""} />
                        <div className="flex my-2">
                            <div>
                                <input type="text" onChange={(e)=>setSearchText(e.currentTarget.value)} className="text-box h-8" placeholder="Search CDD...." />
                            </div>
                            <div className="ms-auto flex gap-4 items-center mx-2">
                                {db_pipeline && (
                                    <CalculateRevenueBtn pipeline={db_pipeline} />
                                )}
                                <div>
                                    <ColumnFilters onFilter={(cols : string[]) => setFilterCol(cols)} />
                                </div>
                                <div>
                                    <StatusFilter onFilter={(numbers : number[])=>setFilterNum(numbers)} />
                                </div>
                                <div className="flex gap-4 text-xl text-gray-700">
                                    <div>
                                        <button className="hover:text-orange-500" onClick={decrementYear}>
                                            <FontAwesomeIcon icon={faAngleLeft} />
                                        </button>
                                    </div>
                                    <div>
                                        {year ? year : currentYear}
                                    </div>
                                    <div>
                                        <button className="hover:text-orange-500" onClick={incrementYear}>
                                            <FontAwesomeIcon icon={faAngleRight} />
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <button type="button" onClick={()=>createModalContent(<AddCdd onClose={()=>setShowModal(false)} account_id={account_id} />)} className="button button-vcc-primary text-sm">
                                        Add new cdd
                                    </button>
                                </div>
                            </div>
                        </div>
                        <CddPipeLineTable
                            u_id={account_id ? account_id : 0}
                            year={year}
                            filter={filterNum}
                            filterCol={filterCol}
                            searchFilter={searchText}
                            newCddAdded={showModal}
                            pipeline={(data)=>set_db_pipeline(data)}
                            full_access={false}
                        />
                    </div>
                </div>
            </div>
            {showModal && (
                <Modal onClose={()=>{setShowModal(false)}}> 
                    {modalChildren}
                </Modal>
             )}
        </div>
    )
}

export default CddPipeLine;